import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vShow as _vShow } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  id: "pickup-manifest",
  class: "relative bg-gray-lp-1200 flex flex-col text-12px xxl:text-14px overflow-hidden h-screen w-full"
}
const _hoisted_2 = { class: "bg-white flex flex-col justify-between items-start border-b border-gray-lp-400 z-20 relative px-6" }
const _hoisted_3 = { class: "flex flex-row py-2 align-middle items-center justify-between w-full" }
const _hoisted_4 = { class: "text-black-lp-200 flex flex-row items-center flex-no-wrap relative" }
const _hoisted_5 = {
  class: "text-24px mr-2 font-bold",
  style: {"align-self":"center"}
}
const _hoisted_6 = { class: "text-16px mr-2 font-semibold" }
const _hoisted_7 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("g", { "clip-path": "url(#clip0_14569_144996)" }, [
  /*#__PURE__*/_createVNode("path", {
    d: "M15.8333 17.4986L17.2458 13.6132C17.3157 13.4211 17.3125 13.2101 17.237 13.0202C17.1614 12.8303 17.0186 12.6747 16.8358 12.5832L10.3725 9.35156C10.2568 9.29376 10.1293 9.26367 10 9.26367C9.8707 9.26367 9.74317 9.29376 9.6275 9.35156L3.16417 12.5832C2.98133 12.6747 2.83848 12.8302 2.76281 13.0201C2.68713 13.21 2.68391 13.4211 2.75375 13.6132L4.16667 17.4986",
    stroke: "#333333",
    "stroke-width": "2",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M12.0833 5.83268V2.49935C12.0833 2.27834 11.9955 2.06637 11.8392 1.91009C11.6829 1.75381 11.4709 1.66602 11.2499 1.66602H8.74992C8.5289 1.66602 8.31694 1.75381 8.16066 1.91009C8.00438 2.06637 7.91659 2.27834 7.91659 2.49935V5.83268M14.5833 5.83268H5.41659C5.19557 5.83268 4.98361 5.92048 4.82733 6.07676C4.67105 6.23304 4.58325 6.445 4.58325 6.66602V11.666L9.65075 9.32727C9.76022 9.27675 9.87935 9.25059 9.99992 9.25059C10.1205 9.25059 10.2396 9.27675 10.3491 9.32727L15.4166 11.666V6.66602C15.4166 6.445 15.3288 6.23304 15.1725 6.07676C15.0162 5.92048 14.8043 5.83268 14.5833 5.83268Z",
    stroke: "#333333",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M10 13.332V16.6654",
    stroke: "#333333",
    "stroke-width": "2",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M1.66663 18.3333C3.33329 18.3333 3.33329 17.5 4.58329 17.5C5.83329 17.5 5.83329 18.3333 7.08329 18.3333C8.33329 18.3333 8.54163 17.5 9.99996 17.5C11.4583 17.5 11.6666 18.3333 12.9166 18.3333C14.1666 18.3333 14.1666 17.5 15.4166 17.5C16.6666 17.5 16.6666 18.3333 18.3333 18.3333",
    stroke: "#333333",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("defs", null, [
  /*#__PURE__*/_createVNode("clipPath", { id: "clip0_14569_144996" }, [
    /*#__PURE__*/_createVNode("rect", {
      width: "20",
      height: "20",
      fill: "white"
    })
  ])
], -1)
const _hoisted_10 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.9787 16.8042C5.6657 16.3675 5.58244 15.8067 5.75508 15.2978L6.67458 12.5877L6.17417 12.5877L5.50715 13.4904C5.19291 13.9157 4.6955 14.1667 4.16671 14.1667L3.33337 14.1667C2.75841 14.1667 2.22405 13.8703 1.91958 13.3826C1.61511 12.8949 1.58352 12.2846 1.83602 11.7681L2.70026 10L1.83602 8.23191C1.58352 7.71536 1.61511 7.10514 1.91958 6.61741C2.22405 6.12968 2.75841 5.83333 3.33337 5.83333L4.16671 5.83333C4.6955 5.83333 5.19291 6.08427 5.50716 6.50956L6.17417 7.41228L6.67458 7.41228L5.75508 4.70216C5.58244 4.19334 5.6657 3.6325 5.9787 3.19577C6.29171 2.75904 6.79606 2.5 7.33337 2.5L8.66671 2.5C9.21913 2.5 9.73565 2.77372 10.0458 3.23083L12.8832 7.41228L15.6667 7.41228C17.0088 7.41228 18.3334 8.44348 18.3334 10C18.3334 11.5565 17.0088 12.5877 15.6667 12.5877L12.8832 12.5877L10.0458 16.7692C9.73565 17.2263 9.21913 17.5 8.66671 17.5L7.33337 17.5C6.79606 17.5 6.29171 17.241 5.9787 16.8042ZM7.83731 10.9211C8.40799 10.9211 8.80982 11.4817 8.62646 12.0221L7.33337 15.8333L8.66671 15.8333L11.7521 11.2865C11.9072 11.0579 12.1654 10.9211 12.4416 10.9211L15.6667 10.9211C16.22 10.9211 16.6667 10.5096 16.6667 10C16.6667 9.49035 16.22 9.07895 15.6667 9.07895L12.4416 9.07895C12.1654 9.07895 11.9072 8.94209 11.7521 8.71353L8.66671 4.16667L7.33337 4.16667L8.62646 7.97787C8.80982 8.51828 8.40799 9.07895 7.83731 9.07895L5.75377 9.07895C5.48938 9.07895 5.24067 8.95348 5.08355 8.74084L4.16671 7.5L3.33337 7.5L4.55538 10L3.33337 12.5L4.16671 12.5L5.08355 11.2592C5.24067 11.0465 5.48938 10.9211 5.75377 10.9211L7.83731 10.9211Z",
  fill: "#333333"
}, null, -1)
const _hoisted_12 = {
  key: 2,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.6667 5.00035C11.2065 5.00034 10.8334 5.37343 10.8334 5.83368V15.0003H9.02373C8.9006 14.6521 8.70064 14.3321 8.43447 14.0659C7.96563 13.5971 7.32975 13.3337 6.66671 13.3337C6.00367 13.3337 5.36778 13.5971 4.89894 14.0659C4.63277 14.3321 4.43282 14.6521 4.30968 15.0003H4.16671V13.3337C4.16671 12.8734 3.79361 12.5003 3.33337 12.5003C2.87314 12.5003 2.50004 12.8734 2.50004 13.3337V15.0003C2.50004 15.4424 2.67563 15.8663 2.9882 16.1788C3.30076 16.4914 3.72468 16.667 4.16671 16.667H4.30968C4.43282 17.0152 4.63277 17.3353 4.89894 17.6014C5.36778 18.0703 6.00367 18.3337 6.66671 18.3337C7.32975 18.3337 7.96563 18.0703 8.43447 17.6014C8.70064 17.3353 8.9006 17.0152 9.02373 16.667H10.8334C11.1285 16.667 11.4155 16.5887 11.6667 16.4437C11.9179 16.5887 12.2049 16.667 12.5 16.667H12.643C12.7661 17.0152 12.9661 17.3353 13.2323 17.6014C13.7011 18.0703 14.337 18.3337 15 18.3337C15.6631 18.3337 16.299 18.0703 16.7678 17.6014C17.034 17.3353 17.2339 17.0152 17.3571 16.667H17.5C17.9421 16.667 18.366 16.4914 18.6786 16.1788C18.9911 15.8663 19.1667 15.4424 19.1667 15.0003V11.1785C19.1666 10.7365 18.991 10.3126 18.6784 10.0001L15.8335 7.15524C15.521 6.84271 15.097 6.66709 14.655 6.66699H12.5C12.5 6.47917 12.5 6.15006 12.5 5.83363C12.5 5.3734 12.127 5.00036 11.6667 5.00035ZM12.643 15.0003H12.5V8.33366L14.6549 8.33375L17.5 11.1788V15.0003H17.3571C17.2339 14.6521 17.034 14.3321 16.7678 14.0659C16.299 13.5971 15.6631 13.3337 15 13.3337C14.337 13.3337 13.7011 13.5971 13.2323 14.0659C12.9661 14.3321 12.7661 14.6521 12.643 15.0003ZM6.07745 15.2444C6.23373 15.0881 6.44569 15.0003 6.66671 15.0003C6.88772 15.0003 7.09968 15.0881 7.25596 15.2444C7.41224 15.4007 7.50004 15.6126 7.50004 15.8337C7.50004 16.0547 7.41224 16.2666 7.25596 16.4229C7.09968 16.5792 6.88772 16.667 6.66671 16.667C6.44569 16.667 6.23373 16.5792 6.07745 16.4229C5.92117 16.2666 5.83337 16.0547 5.83337 15.8337C5.83337 15.6126 5.92117 15.4007 6.07745 15.2444ZM14.4108 15.2444C14.5671 15.0881 14.779 15.0003 15 15.0003C15.2211 15.0003 15.433 15.0881 15.5893 15.2444C15.7456 15.4007 15.8334 15.6126 15.8334 15.8337C15.8334 16.0547 15.7456 16.2666 15.5893 16.4229C15.433 16.5792 15.2211 16.667 15 16.667C14.779 16.667 14.5671 16.5792 14.4108 16.4229C14.2545 16.2666 14.1667 16.0547 14.1667 15.8337C14.1667 15.6126 14.2545 15.4007 14.4108 15.2444Z",
  fill: "#333333"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.33337 1.66699C3.79361 1.66699 4.16671 2.04009 4.16671 2.50033V3.33366H6.66671V2.50033C6.66671 2.04009 7.0398 1.66699 7.50004 1.66699C7.96028 1.66699 8.33337 2.04009 8.33337 2.50033V3.33366C8.33337 3.38076 8.32947 3.42694 8.32196 3.47191C9.29891 3.81186 10 4.74088 10 5.83366V9.16699C10 10.5477 8.88075 11.667 7.50004 11.667H3.33337C1.95266 11.667 0.833374 10.5477 0.833374 9.16699V5.83366C0.833374 4.74088 1.5345 3.81186 2.51146 3.47191C2.50395 3.42694 2.50004 3.38076 2.50004 3.33366V2.50033C2.50004 2.04009 2.87314 1.66699 3.33337 1.66699ZM3.33337 5.00033C2.87314 5.00033 2.50004 5.37342 2.50004 5.83366V9.16699C2.50004 9.62723 2.87314 10.0003 3.33337 10.0003H7.50004C7.96028 10.0003 8.33337 9.62723 8.33337 9.16699V5.83366C8.33337 5.37342 7.96028 5.00033 7.50004 5.00033H3.33337ZM5.00004 7.50033C5.00004 7.04009 5.37314 6.66699 5.83337 6.66699H6.66671C7.12694 6.66699 7.50004 7.04009 7.50004 7.50033V8.33366C7.50004 8.7939 7.12694 9.16699 6.66671 9.16699H5.83337C5.37314 9.16699 5.00004 8.7939 5.00004 8.33366V7.50033Z",
  fill: "#333333"
}, null, -1)
const _hoisted_15 = { class: "text-16px ml-2 mr-4 font-semibold" }
const _hoisted_16 = {
  key: 3,
  class: "inline-block ml-1 mr-2"
}
const _hoisted_17 = {
  key: 4,
  class: "mr-2 bg-red-lp-1300 rounded text-center text-red-lp-2000 font-semibold text-xs p-1"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" DG ")
const _hoisted_19 = {
  key: 5,
  class: "mr-2 bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-semibold text-xs p-1"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" K ")
const _hoisted_21 = { class: "flex items-center gap-x-4" }
const _hoisted_22 = { class: "px-2 pt-2 w-180px font-montserrat" }
const _hoisted_23 = {
  key: 0,
  class: "bg-white"
}
const _hoisted_24 = { class: "flex gap-x-6 text-16px border-b border-gray-lp-400 pt-3 px-6" }
const _hoisted_25 = { class: "hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_WidgetDownloadCargo = _resolveComponent("WidgetDownloadCargo")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Print = _resolveComponent("Print")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _imports_0,
            alt: "arrow-left",
            class: "h-5 mr-2 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }),
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.cargoNo), 1),
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.detailData.originCityCode) + " - " + _toDisplayString(_ctx.detailData.originCityName), 1),
          (_ctx.detailData.cargoType === 'ship')
            ? (_openBlock(), _createBlock("svg", _hoisted_7, [
                _hoisted_8,
                _hoisted_9
              ]))
            : (_ctx.detailData.cargoType === 'plane')
              ? (_openBlock(), _createBlock("svg", _hoisted_10, [
                  _hoisted_11
                ]))
              : (_ctx.detailData.cargoType === 'truck')
                ? (_openBlock(), _createBlock("svg", _hoisted_12, [
                    _hoisted_13,
                    _hoisted_14
                  ]))
                : _createCommentVNode("", true),
          _createVNode("span", _hoisted_15, _toDisplayString(_ctx.detailData.destinationCityCode) + " - " + _toDisplayString(_ctx.detailData.destinationCityName), 1),
          (_ctx.detailData.isDisputeCargo)
            ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_16, [
                _createVNode(_component_Icons, {
                  name: "kg-dispute",
                  class: "text-red-lp-100",
                  style: {"width":"24px","height":"24px"}
                })
              ], 512)), [
                [
                  _directive_tooltip,
                  _ctx.$t('cargo.v2.detail.tooltip.cargoWeightDispute'),
                  void 0,
                  { bottom: true }
                ]
              ])
            : _createCommentVNode("", true),
          (_ctx.detailData.cargoCommodityGroupIsDg || _ctx.isRtcDg)
            ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_17, [
                _hoisted_18
              ], 512)), [
                [
                  _directive_tooltip,
                  'Dangerous Goods',
                  void 0,
                  { bottom: true }
                ]
              ])
            : _createCommentVNode("", true),
          (_ctx.detailData.cargoCommodityGroupIsQuarantine || _ctx.isRtcQuarantine)
            ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_19, [
                _hoisted_20
              ], 512)), [
                [
                  _directive_tooltip,
                  _ctx.$t('cargo.v2.detail.badge.quarantine'),
                  void 0,
                  { bottom: true }
                ]
              ])
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_21, [
          (
              _ctx.detailData.cargoStatus === 'cancel' ||
                _ctx.detailData.cargoStatus === 'failed'
            )
            ? (_openBlock(), _createBlock(_component_lp_button, {
                key: 0,
                outline: "",
                title: _ctx.$t('cargo.v2.detail.action.delete'),
                color: "gray-lp-600",
                textColor: "gray-lp-300",
                onClick: _cache[2] || (_cache[2] = 
              () => {
                _ctx.openModalDelete(_ctx.detailData);
              }
            )
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          (
              _ctx.detailData.cargoStatus === 'cancel' ||
                _ctx.detailData.cargoStatus === 'failed'
            )
            ? (_openBlock(), _createBlock(_component_lp_button, {
                key: 1,
                outline: "",
                title: _ctx.$t('cargo.v2.detail.action.rebook'),
                color: "red-lp-2400",
                textColor: "red-lp-2400",
                onClick: _cache[3] || (_cache[3] = 
              () => {
                _ctx.openModalReBooking(_ctx.detailData);
              }
            )
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          (_ctx.ableToEdit && !_ctx.detailData.cargoStatus)
            ? (_openBlock(), _createBlock(_component_lp_button, {
                key: 2,
                outline: "",
                title: _ctx.$t('cargo.v2.detail.action.editBooking'),
                color: "gray-lp-600",
                textColor: "gray-lp-300",
                onClick: _cache[4] || (_cache[4] = () => _ctx.goToEdit())
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          (!_ctx.detailData.cargoStatus)
            ? (_openBlock(), _createBlock(_component_lp_button, {
                key: 3,
                outline: "",
                icon: "chevron-down-light",
                title: "Print label",
                color: "red-lp-2400",
                textColor: "red-lp-2400",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.openPrintPopover($event)), ["stop"]))
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_OverlayPanel, { ref: "printLabel" }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_22, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.actionGroupOptions, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "w-full mb-2 py-2 cursor-pointer text-sm",
                    key: item.label,
                    onClick: () => item.clickFunction()
                  }, [
                    _createVNode("p", null, _toDisplayString(item.label), 1)
                  ], 8, ["onClick"]))
                }), 128))
              ])
            ]),
            _: 1
          }, 512)
        ])
      ])
    ]),
    (_ctx.detailData.cargoType === 'plane' && !_ctx.$route.query?.rc_no)
      ? (_openBlock(), _createBlock("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createBlock("div", {
                key: tab.name,
                class: "flex flex-row"
              }, [
                _createVNode("button", {
                  onClick: ($event: any) => (_ctx.changeTabs(tab)),
                  class: 
              `pb-4 font-semibold hover:text-red-lp-100 focus:outline-none ${
                _ctx.isTabActive(tab.name)
                  ? 'text-red-lp-100 border-b-2 border-red-lp-100'
                  : 'text-gray-lp-600'
              }`
            ,
                  "data-testid": tab.dataTestid
                }, _toDisplayString(tab.title), 11, ["onClick", "data-testid"])
              ]))
            }), 128))
          ]),
          (!_ctx.$route.query?.rc_no && !_ctx.permissionDownloadAwbReceiptSync)
            ? (_openBlock(), _createBlock(_component_WidgetDownloadCargo, {
                key: 0,
                onSuccessPrintAwb: _ctx.onSuccessPrintAwb
              }, null, 8, ["onSuccessPrintAwb"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, {
      key: _ctx.$route.name
    }),
    _createVNode("div", _hoisted_25, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.confirmDelete,
      onClose: _ctx.closeModalDelete,
      title: _ctx.$t('cargo.v2.detail.modal.delete.title'),
      message: _ctx.deleteModalMessage,
      image: "badge-confirmation-general",
      textSuccess: _ctx.$t('cargo.actions.yesDelete'),
      textCancel: _ctx.$t('cargo.actions.cancelBooking'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.showModalDelete]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.goToReBooking,
      onClose: _ctx.closeModalReBooking,
      title: _ctx.$t('cargo.v2.detail.modal.rebook.title'),
      message: _ctx.rebookModalMessage,
      image: "badge-confirmation-general",
      textSuccess: _ctx.$t('cargo.actions.yesRebook'),
      textCancel: _ctx.$t('cargo.actions.cancelBooking'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.showModalReBooking]
    ])
  ]))
}